// Mock data for NV Digital Marketing Agency Portfolio

export const agencyInfo = {
  name: "NV Digital Marketing Agency",
  owner: "KARTHIPAN KARUNAMOORTHY",
  tagline: "Connecting Ambitions, Achieving Potency",
  logo: "https://customer-assets.emergentagent.com/job_32f275e2-4426-4c73-b9b8-ea30afbab5b1/artifacts/s99jobdg_IMG-20250629-WA0001.jpg",
  whatsapp: ["+94755041226", "+16673699479"],
  email: "nvdigitalmaketingagency@gmail.com",
  locations: [
    {
      country: "USA",
      city: "Maryland",
      full: "Maryland, USA",
      flag: "🇺🇸"
    },
    {
      country: "Sri Lanka",
      city: "Trincomalee",
      full: "Trincomalee, Sri Lanka",
      flag: "🇱🇰"
    }
  ]
};

export const services = [
  {
    id: "1",
    title: "Video Editing",
    description: "Professional video editing services that bring your stories to life with cinematic quality and creative flair.",
    icon: "Video",
    features: ["Color Grading", "Motion Graphics", "Sound Design", "Post Production"]
  },
  {
    id: "2",
    title: "Content Creation",
    description: "Engaging content that resonates with your audience across all digital platforms and drives meaningful interactions.",
    icon: "PenTool",
    features: ["Social Media Content", "Blog Writing", "Copywriting", "Brand Storytelling"]
  },
  {
    id: "3",
    title: "Full Stack Development",
    description: "End-to-end web solutions from concept to deployment, built with cutting-edge technologies and best practices.",
    icon: "Code",
    features: ["Web Applications", "E-commerce", "APIs", "Database Design"]
  },
  {
    id: "4",
    title: "Story Telling",
    description: "Crafting compelling narratives that connect your brand with audiences on an emotional level.",
    icon: "BookOpen",
    features: ["Brand Stories", "Campaign Narratives", "Visual Storytelling", "Content Strategy"]
  },
  {
    id: "5",
    title: "Digital Marketing",
    description: "Strategic digital marketing campaigns that amplify your brand and deliver measurable results.",
    icon: "TrendingUp",
    features: ["SEO", "Social Media Marketing", "Email Campaigns", "Analytics"]
  },
  {
    id: "6",
    title: "Ethical Hacking",
    description: "Comprehensive security assessments to protect your digital assets and ensure robust cybersecurity.",
    icon: "Shield",
    features: ["Penetration Testing", "Vulnerability Assessment", "Security Audits", "Risk Analysis"]
  },
  {
    id: "7",
    title: "Graphic Design",
    description: "Stunning visual designs that capture attention and communicate your brand message effectively.",
    icon: "Palette",
    features: ["Brand Identity", "Logo Design", "Marketing Materials", "UI/UX Design"]
  }
];

export const portfolioProjects = [
  {
    id: "1",
    title: "E-Commerce Platform Redesign",
    category: "Full Stack Development",
    description: "Complete redesign and development of a high-performance e-commerce platform with seamless user experience.",
    image: "https://images.unsplash.com/photo-1547658719-da2b51169166",
    tags: ["React", "Node.js", "MongoDB", "Payment Integration"],
    year: "2024"
  },
  {
    id: "2",
    title: "Brand Identity Suite",
    category: "Graphic Design",
    description: "Comprehensive brand identity design including logo, color palette, and marketing collateral.",
    image: "https://images.unsplash.com/photo-1561070791-2526d30994b5",
    tags: ["Branding", "Logo Design", "Style Guide", "Print Design"],
    year: "2024"
  },
  {
    id: "3",
    title: "Corporate Video Production",
    category: "Video Editing",
    description: "High-impact corporate video showcasing company culture and values with professional editing.",
    image: "https://images.unsplash.com/photo-1559028012-481c04fa702d",
    tags: ["Video Editing", "Color Grading", "Motion Graphics", "Sound Design"],
    year: "2024"
  },
  {
    id: "4",
    title: "Social Media Campaign",
    category: "Digital Marketing",
    description: "Multi-platform social media campaign that increased engagement by 300% and drove significant conversions.",
    image: "https://images.pexels.com/photos/6633921/pexels-photo-6633921.jpeg",
    tags: ["Social Media", "Content Strategy", "Analytics", "Paid Ads"],
    year: "2023"
  },
  {
    id: "5",
    title: "SaaS Application Development",
    category: "Full Stack Development",
    description: "Custom SaaS solution with advanced features, real-time collaboration, and scalable architecture.",
    image: "https://images.unsplash.com/photo-1499951360447-b19be8fe80f5",
    tags: ["React", "FastAPI", "WebSocket", "Cloud Hosting"],
    year: "2024"
  },
  {
    id: "6",
    title: "Security Audit & Penetration Testing",
    category: "Ethical Hacking",
    description: "Comprehensive security assessment identifying vulnerabilities and implementing robust security measures.",
    image: "https://images.pexels.com/photos/270632/pexels-photo-270632.jpeg",
    tags: ["Penetration Testing", "Vulnerability Assessment", "Security Report", "Risk Mitigation"],
    year: "2023"
  },
  {
    id: "7",
    title: "Content Marketing Strategy",
    category: "Content Creation",
    description: "Strategic content creation across multiple channels driving brand awareness and lead generation.",
    image: "https://images.unsplash.com/photo-1626785774573-4b799315345d",
    tags: ["Blogging", "SEO Content", "Copywriting", "Email Marketing"],
    year: "2024"
  },
  {
    id: "8",
    title: "Brand Story Documentary",
    category: "Story Telling",
    description: "Compelling documentary-style brand story that humanizes the company and connects with audiences emotionally.",
    image: "https://images.unsplash.com/photo-1626785774625-ddcddc3445e9",
    tags: ["Narrative Design", "Video Production", "Interviews", "Emotional Storytelling"],
    year: "2023"
  },
  {
    id: "9",
    title: "UI/UX Design System",
    category: "Graphic Design",
    description: "Comprehensive design system with reusable components ensuring consistency across digital products.",
    image: "https://images.unsplash.com/photo-1667400104764-a5fd01a919b0",
    tags: ["UI Design", "UX Research", "Design System", "Prototyping"],
    year: "2024"
  },
  {
    id: "10",
    title: "Mobile App Development",
    category: "Full Stack Development",
    description: "Cross-platform mobile application with intuitive interface and seamless backend integration.",
    image: "https://images.unsplash.com/photo-1611532736597-de2d4265fba3",
    tags: ["React Native", "Mobile UI", "API Integration", "App Store Launch"],
    year: "2023"
  }
];

export const testimonials = [
  {
    id: "1",
    name: "Sarah Johnson",
    role: "CEO, TechStart Inc",
    content: "NV Digital transformed our online presence completely. Their full stack development and digital marketing expertise helped us scale from startup to industry leader.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150"
  },
  {
    id: "2",
    name: "Michael Chen",
    role: "Marketing Director, GrowthCo",
    content: "The video editing and storytelling services exceeded our expectations. Karthipan's creative vision brought our brand story to life in ways we never imagined.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150"
  },
  {
    id: "3",
    name: "Emily Rodriguez",
    role: "Founder, Creative Studios",
    content: "Outstanding graphic design and branding work. NV Digital truly understands how to create visual identities that resonate with target audiences.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150"
  },
  {
    id: "4",
    name: "David Kumar",
    role: "CTO, SecureNet",
    content: "Their ethical hacking and security audit services are top-notch. We now have complete confidence in our digital security infrastructure.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150"
  }
];

export const aboutContent = {
  bio: "Hi, I'm Karthipan Karunamoorthy, the founder of NV Digital Marketing Agency. With over 8 years of experience in the digital landscape, I've helped businesses transform their online presence through innovative digital solutions. My journey began with a passion for technology and creativity, which evolved into a full-service digital agency offering everything from video editing to ethical hacking.",
  mission: "To empower businesses by connecting their ambitions with digital potency, delivering exceptional results through creativity, innovation, and technical excellence.",
  vision: "To be the leading digital agency that transforms how brands communicate, engage, and succeed in the digital world.",
  experience: "8+ Years",
  projectsCompleted: "150+",
  happyClients: "80+",
  awards: "12",
  skills: [
    { name: "Video Editing", level: 95 },
    { name: "Full Stack Development", level: 90 },
    { name: "Digital Marketing", level: 92 },
    { name: "Graphic Design", level: 88 },
    { name: "Content Strategy", level: 90 },
    { name: "Cybersecurity", level: 85 }
  ]
};

export const stats = [
  { label: "Years Experience", value: "8+", icon: "Award" },
  { label: "Projects Completed", value: "150+", icon: "CheckCircle" },
  { label: "Happy Clients", value: "80+", icon: "Users" },
  { label: "Awards Won", value: "12", icon: "Trophy" }
];

// Admin credentials for editing panel (mock)
export const adminCredentials = {
  password: "Oneness143"
};